/**
 * Placeholder pack for the locked (`metrics`) Season summary.
 * Keeps only the header fields and the three variety names from the server pack; every number
 * and every importer/exporter/region row is a fixed local constant, never derived from real values.
 */

const VARIETY_FAKES = [
  { tonnes: 1200, tonnes_ly: 1000, share: 38.0, yoy_pct: 12 },
  { tonnes: 860, tonnes_ly: 900, share: 27.0, yoy_pct: -8 },
  { tonnes: 540, tonnes_ly: 600, share: 17.0, yoy_pct: 3 },
];

const fakeRow = (label, n, extra = {}) => ({
  name: `${label} ${n}`,
  tonnes: 1000 - n * 120,
  tonnes_ly: 950 - n * 110,
  share: 30 - n * 4,
  yoy_pct: n % 2 ? 9 : -6,
  ...extra,
});

// Origin labels follow the selected scope suffix (USA__PERU), the same rule the real pack uses.
function originsOf(scope) {
  const sfx = String(scope || '').split('__')[1];
  if (sfx === 'PERU') return ['Peru'];
  if (sfx === 'CHILE') return ['Chile'];
  return ['Peru', 'Chile'];
}

// USA only: the real modal shows the historical outlook there. Fixed fake values, blurred in the modal.
const OUTLOOK_FAKES = {
  outlook_share: { ok: true, peru_ty_pct: 55, peru_ly_pct: 48 },
  outlook_fob: {
    ok: true,
    expensive_usd: 40,
    expensive_week: 45,
    next8: [
      { week: 43, usd: 38 },
      { week: 50, usd: 36 },
    ],
  },
};

export function lockedPlaceholderPack(pack) {
  if (pack == null || typeof pack !== 'object' || pack.locked !== true) return pack ?? null;
  const names = (Array.isArray(pack.varieties) ? pack.varieties : []).slice(0, 3);
  return {
    locked: true,
    kind: pack.kind,
    destination: pack.destination,
    commodity: pack.commodity,
    generated_at: pack.generated_at,
    scope: pack.scope,
    season_label: pack.season_label,
    origin_countries: originsOf(pack.scope),
    // Alloy sidecar is dest-independent peak/on/light; keep it on the teaser.
    ...(pack.season_calendar && typeof pack.season_calendar === 'object'
      ? { season_calendar: pack.season_calendar }
      : {}),
    ...(String(pack.destination || '').toUpperCase() === 'USA' ? OUTLOOK_FAKES : {}),
    varieties: names.map((v, i) => ({
      name: v?.name,
      ...VARIETY_FAKES[i],
      top_region: 'Region 1',
      top_region_pct: 50,
    })),
    peak_week: 42,
    peak_tonnes: 1500,
    yoy_pct: 6,
    region_dest: [1, 2, 3].map((n) => ({
      region: `Region ${n}`,
      tonnes: 1000 - n * 200,
      share: 50 - n * 10,
      yoy_pct: n % 2 ? 7 : -5,
      tonnes_ly: 950 - n * 190,
    })),
    importers: [1, 2, 3, 4, 5].map((n) =>
      fakeRow('Importer', n, { top_variety: 'Variety 1', top_region: 'Region 1' }),
    ),
    exporters: [1, 2, 3, 4, 5].map((n) =>
      fakeRow('Exporter', n, { top_variety: 'Variety 1', top_region: 'Region 1' }),
    ),
  };
}
